import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black" }, "Attach custom note", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500 pb-4" }, "Attach a custom note to the enrolled leads.", -1)
const _hoisted_4 = { class: "flex items-center gap-x-1 pb-6" }

import { watch } from "vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsRichTextEditor from "@/components/GgmsRichTextEditor.vue"
import { InformationCircleIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { stripHtml } from "@/shared/utils/helpers"


export default /*#__PURE__*/_defineComponent({
  __name: 'NoteComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

watch(
    () => [workflowStore.modelValue.event, workflowStore.modelValue.value],
    () => {
        workflowStore.areButtonDisabled = !stripHtml(workflowStore.modelValue as string)
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(GgmsCheckBox, {
        modelValue: _unref(workflowStore).modelValue.event,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.event) = $event)),
        label: "Pin note"
      }, null, 8, ["modelValue"]),
      _createVNode(_unref(InformationCircleIcon), { class: "w-4 h-4 cursor-pointer" })
    ]),
    _createVNode(GgmsRichTextEditor, {
      modelValue: _unref(workflowStore).modelValue.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.value) = $event)),
      placeholder: "Write your note...."
    }, null, 8, ["modelValue"])
  ]))
}
}

})